<script setup lang="ts">
import { ref, toRefs, watch } from 'vue';
import { useDisplay } from 'vuetify';

type Props = {
  modelValue: boolean;
};
const props = defineProps<Props>();
const { modelValue } = toRefs(props);

const { smAndDown } = useDisplay();

// v-bottom-sheet needs its own open state; mirror the host's flag into it.
const isOpen = ref(modelValue.value);
watch(modelValue, (value) => {
  isOpen.value = value;
});
</script>

<template>
  <v-bottom-sheet
    v-if="smAndDown"
    v-model="isOpen"
    persistent
    :scroll-strategy="'none'"
    :retain-focus="false"
    :scrim="false"
  >
    <div class="d-flex justify-space-around bg-surface-container selection-bar align-center">
      <slot></slot>
    </div>
  </v-bottom-sheet>
</template>

<style scoped lang="scss">
.selection-bar {
  // Height plus the safe area, not 80px total: `box-sizing: border-box` made the inset eat into the
  // row, clipping the top of the buttons on devices that have one.
  min-height: 80px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1005;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
</style>
